export default {
    logoutText: 'Logg ut',
    keepAliveTitle: 'Er du der?',
    keepAliveDescription: 'Av hensyn til din sikkerhet sjekker vi om du fortsatt er her etter en viss tid.',
    keepAliveConfirmationButtonText: 'Ja, jeg er her',
};
